import { useContext } from 'react';
import ModalContext from '../ModalProvider/context';

export default () => useContext(ModalContext);
